import { INHABITANT_STATUS } from '../../../../constants/inhabitant'
import { TableEmptyCell, TableStatusCell } from '../../../Table'

function DocFlowTableCellRecipientStatus(props) {
  const { value } = props

  return value >= 0 ? (
    <TableStatusCell {...props} statuses={INHABITANT_STATUS} />
  ) : (
    <TableEmptyCell {...props} />
  )
}

export default DocFlowTableCellRecipientStatus
